import React, { Component } from 'react';
import { withRouter } from "react-router-dom";
import CONFIG from '../CONFIG.json';

class LoginLayout extends Component {
    constructor(props) {
        super(props);
        this.state={};
    }


    componentWillMount(){
      document.body.classList.add("bodyLogin");
    }

    componentDidMount(){
        document.title = CONFIG.nombre +" | "+CONFIG.descripcion;
    }
    render() {
        return <React.Fragment>
              <div id="preloader">
                  <div id="status">
                      <div className="spinner-chase">
                          <div className="chase-dot"></div>
                          <div className="chase-dot"></div>
                          <div className="chase-dot"></div>
                          <div className="chase-dot"></div>
                          <div className="chase-dot"></div>
                          <div className="chase-dot"></div>
                      </div>
                  </div>
              </div>
            {this.props.children}
        </React.Fragment>;
    }
}

export default (withRouter(LoginLayout));
